import { InputBase } from '../../../classes/input-base';
import { InputText } from '../../../classes/input-text';
import { FeaturesStep4Form } from './features-step4-form';
import { InputRadio } from '../../../classes/input-radio';

export class FeaturesStep4FormAudioThicket extends FeaturesStep4Form {
	amazonLink = new InputText({
		key: 'amazonLink',
		label: 'Amazon Audiobook URL',
		buttonSymbol: 'Go',
		blur: true,
		tooltipText: 'Please input the Amazon Audiobook URL for your book if you have one. If your audiobook is not'
      + ' available on Amazon, leave this field blank. ',
		tooltip: '?',
	});

	narrator = new InputText({
		key: 'narrator',
		label: 'Narrator',
		required: true,
	});

	similarAuthors = new InputText({
		key: 'similarAuthors',
		label: 'Similar Authors',
	});

	email = new InputText({
		key: 'email',
		label: 'Email',
		required: true,
		pattern: 'email',
		helper: 'This is where we will send your confirmation email.',
	});

	audiblePrice = new InputText({
		key: 'audiblePrice',
		label: '',
		type: 'number',
	});

	audibleIsPrimaryLink = new InputRadio({
		key: 'audibleIsPrimaryLink',
		value: 'audible',
	});

	appleAudioPrice = new InputText({
		key: 'appleAudioPrice',
		label: '',
		type: 'number',
	});

	appleAudioIsPrimaryLink = new InputRadio({
		key: 'appleAudioIsPrimaryLink',
		value: 'appleAudio',
	});

	koboAudioPrice = new InputText({
		key: 'koboAudioPrice',
		label: '',
		type: 'number',
	});

	appleAudioLink = new InputText({
		key: 'appleAudioLink',
		label: '',
		placeholder: 'Enter apple audio link here',
	});

	koboAudioLink = new InputText({
		key: 'koboAudioLink',
		label: '',
		placeholder: 'Enter kobo audio link here',
	});

	pandoraIsPrimaryLink = new InputRadio({
		key: 'pandoraIsPrimaryLink',
		value: 'pandora',
	});

	spotifyIsPrimaryLink = new InputRadio({
		key: 'spotifyIsPrimaryLink',
		value: 'spotify',
	});

	pandora = new InputBase({
		key: 'pandora',
		label: 'Pandora',
		controlType: 'checkbox',
		value: false,
		reverseInput: true,
	});

	pandoraLink = new InputText({
		key: 'pandoraLink',
		label: '',
		placeholder: 'Enter pandora link here',
	});

	pandoraPrice = new InputText({
		key: 'pandoraPrice',
		label: '',
		type: 'number',
	});

	spotify = new InputBase({
		key: 'spotify',
		label: 'Spotify',
		controlType: 'checkbox',
		value: false,
		reverseInput: true,
	});

	spotifyLink = new InputText({
		key: 'spotifyLink',
		label: '',
		placeholder: 'Enter spotify link here',
	});

	spotifyPrice = new InputText({
		key: 'spotifyPrice',
		label: '',
		type: 'number',
	});

	nookAudioLink = new InputText({
		key: 'nookAudioLink',
		label: '',
		placeholder: 'Enter nook audio link here',
	});

	googleplayAudioLink = new InputText({
		key: 'googleplayAudioLink',
		label: '',
		placeholder: 'Enter google play audio link here',
	});

	appleAudio = new InputBase({
		key: 'appleAudio',
		label: 'Apple Audio',
		controlType: 'checkbox',
		value: false,
		reverseInput: true,
	});

	koboAudio = new InputBase({
		key: 'koboAudio',
		label: 'Kobo Audio',
		controlType: 'checkbox',
		value: false,
		reverseInput: true,
	});

	nookAudio = new InputBase({
		key: 'nookAudio',
		label: 'Nook Audio',
		controlType: 'checkbox',
		value: false,
		reverseInput: true,
	});

	googleplayAudio = new InputBase({
		key: 'googleplayAudio',
		label: 'Google Play Audio',
		controlType: 'checkbox',
		value: false,
		reverseInput: true,
	});

	koboAudioIsPrimaryLink = new InputRadio({
		key: 'koboAudioIsPrimaryLink',
		value: 'koboaudio',
	});

	nookAudioPrice = new InputText({
		key: 'nookAudioPrice',
		label: '',
		type: 'number',
	});

	nookAudioIsPrimaryLink = new InputRadio({
		key: 'nookAudioIsPrimaryLink',
		value: 'nookAudio',
	});

	audiobookscom = new InputBase({
		key: 'audiobookscom',
		label: 'Audiobooks.com',
		controlType: 'checkbox',
		value: false,
		reverseInput: true,
	});

	audiobookscomPrice = new InputText({
		key: 'audiobookscomPrice',
		label: '',
		type: 'number',
	});

	audiobookscomIsPrimaryLink = new InputRadio({
		key: 'audiobookscomIsPrimaryLink',
		value: 'audiobookscom',
	});

	googleplayAudioIsPrimaryLink = new InputRadio({
		key: 'googleplayAudioIsPrimaryLink',
		value: 'googleplayAudio',
	});

	googleplayAudioPrice = new InputText({
		key: 'googleplayAudioPrice',
		label: '',
		type: 'number',
	});

	authorstorePrice = new InputText({
		key: 'authorStorePrice',
		label: '',
		type: 'number',
	});

	smashwordsPrice = new InputText({
		key: 'smashwordsPrice',
		label: '',
		type: 'number',
	});
}
